import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const login = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    try {
      let params = new URLSearchParams();
      params.append("access_token", data.access_token);
      params.append("scope", data.scope);
      params.append("authuser", data.authuser);
      params.append("prompt", data.prompt);
      const url = `${process.env.REACT_APP_API_EXPLORE_BASE_URL}/auth/google/callback?${params}`;
      const res = await axios.get(url);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const loginWithPassword = createAsyncThunk(
  "auth/loginWithPassword",
  async (data, { rejectWithValue }) => {
    try {
      const url = `${process.env.REACT_APP_API_EXPLORE_BASE_URL}/auth/login`;
      const res = await axios.post(url, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
